/*import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs, doc, getDoc } from 'firebase/firestore';
import styles from './applications.module.css';

const AdminInternship = () => {
    const [applications, setApplications] = useState([]);

    useEffect(() => {
      const fetchInternshipApplications = async () => {
        try {
          const q = query(
            collection(db, 'internshipApplications'),
            orderBy('timestamp', 'desc')
          );
          const querySnapshot = await getDocs(q);
          const fetchedApplications = [];
  
          for (const docRef of querySnapshot.docs) {
            const application = docRef.data();
            const userId = application.userId;
            const userDocRef = doc(db, 'users', userId);
            const userDoc = await getDoc(userDocRef);
  
            if (userDoc.exists()) {
              const userData = userDoc.data();
  
              fetchedApplications.push({
                ...application,
                user: {
                  name: `${userData.firstName} ${userData.lastName}`,
                  email: userData.email,
                  phone: userData.phone,
                },
              });
            }
          }
  
          setApplications(fetchedApplications);
        } catch (error) {
          console.error('Error fetching internship applications: ', error);
        }
      };
  
      fetchInternshipApplications();
    }, []);
  
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <h2>Staj Başvuruları</h2>
          <div className={styles.tableContainer}>
            <table className={styles.applicationsTable}>
              <thead>
                <tr>
                  <th>Adı</th>
                  <th>Email</th>
                  <th>Telefon</th>
                  <th>Üniversite</th>
                  <th>Bölüm</th>
                  <th>Mezuniyet Yılı</th>
                  <th>Staj Dönemi</th>
                  <th>İlgilendiği Departmanlar</th>
                  <th>CV</th>
                  <th>Motivasyon Mektubu</th>
                  <th>Transkript</th>
                </tr>
              </thead>
              <tbody>
                {applications.map((application, index) => (
                  <tr key={index}>
                    <td>{application.user.name}</td>
                    <td>{application.user.email}</td>
                    <td>{application.user.phone}</td>
                    <td>{application.university}</td>
                    <td>{application.department}</td>
                    <td>{application.graduationYear}</td>
                    <td>{application.internshipPeriod}</td>
                    <td>{application.interestedDepartments.join(', ')}</td>
                    <td>
                      <a
                        href={application.cvUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Görüntüle
                      </a>
                    </td>
                    <td>
                      <a
                        href={application.motivationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Görüntüle
                      </a>
                    </td>
                    <td>
                      <a
                        href={application.transcriptUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Görüntüle
                      </a>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
};

export default AdminInternship;
*/
/*
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs, doc, getDoc } from 'firebase/firestore';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import styles from './applications.module.css';

const AdminInternship = () => {
  const [applications, setApplications] = useState([]);

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const q = query(collection(db, 'internshipApplications'), orderBy('timestamp', 'desc'));
        const querySnapshot = await getDocs(q);
        const fetchedApplications = [];

        for (const docRef of querySnapshot.docs) {
          const application = docRef.data();
          const userId = application.userId;
          const userDocRef = doc(db, 'users', userId);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            fetchedApplications.push({
              ...application,
              user: {
                email: userData.email,
                firstname: userData.firstName,
                lastname: userData.lastName,
                phone: userData.phone,
              },
            });
          }
        }

        setApplications(fetchedApplications);
      } catch (error) {
        console.error('Error fetching internship applications: ', error);
      }
    };

    fetchApplications();
  }, []);

  // Helper functions for export
  const turkishToEnglishMap = {
    'ş': 's',
    'Ş': 'S',
    'ı': 'i',
    'İ': 'I',
    'ç': 'c',
    'Ç': 'C',
    'ğ': 'g',
    'Ğ': 'G',
    'ü': 'u',
    'Ü': 'U',
    'ö': 'o',
    'Ö': 'O'
  };

  const convertTurkishToEnglish = (text) => {
    return text.split('').map(char => turkishToEnglishMap[char] || char).join('');
  };

  const createSafeFilename = (name) => {
    const englishName = convertTurkishToEnglish(name);
    return englishName.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-+$/, '');
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(
      applications.map((app) => ({
        'İsim Soyisim': `${app.user.firstname || ''} ${app.user.lastname || ''}`,
        'Email': app.user.email || 'N/A',
        'Telefon': app.user.phone || 'N/A',
        'Üniversite': app.university || 'N/A',
        'Bölüm': app.department || 'N/A',
        'Mezuniyet Yılı': app.graduationYear || 'N/A',
        'Staj Dönemi': app.internshipPeriod || 'N/A',
        'İlgilendiği Bölümler': app.interestedDepartments || 'N/A',
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'InternshipApplications');
    XLSX.writeFile(workbook, 'internship_applications.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.setFont('Helvetica');

    const data = applications.map((app) => [
      `${convertTurkishToEnglish(app.user.firstname || '')} ${convertTurkishToEnglish(app.user.lastname || '')}`,
      convertTurkishToEnglish(app.user.email || 'N/A'),
      convertTurkishToEnglish(app.user.phone || 'N/A'),
      convertTurkishToEnglish(app.university || 'N/A'),
      convertTurkishToEnglish(app.department || 'N/A'),
      convertTurkishToEnglish(app.graduationYear || 'N/A'),
      convertTurkishToEnglish(app.internshipPeriod || 'N/A'),
      convertTurkishToEnglish(app.interestedDepartments || 'N/A'),
      app.motivationUrl ? 'Yüklendi' : 'Yüklenmemiş',
      app.transcriptUrl ? 'Yüklendi' : 'Yüklenmemiş',
    ]);

    doc.autoTable({
      head: [
        [
          'İsim Soyisim',
          'Email',
          'Telefon',
          'Üniversite',
          'Bölüm',
          'Mezuniyet Yılı',
          'Staj Dönemi',
          'İlgilendiği Bölümler',
          'Motivasyon Mektubu',
        ],
      ],
      body: data,
    });

    doc.save('internship_applications.pdf');
  };

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <div className={styles.exportButtons}>
          <button className={styles.exportButton} onClick={exportToExcel}>
            Excel'e Aktar
          </button>
          <button className={styles.exportButton} onClick={exportToPDF}>
            PDF'e Aktar
          </button>
        </div>
        <div className={styles.tableContainer}>
          <table className={styles.applicationsTable}>
            <thead>
              <tr>
                <th>İsim Soyisim</th>
                <th>Email</th>
                <th>Telefon</th>
                <th>Üniversite</th>
                <th>Bölüm</th>
                <th>Mezuniyet Yılı</th>
                <th>Staj Dönemi</th>
                <th>İlgilendiği Bölümler</th>
                <th>CV</th>
                <th>Motivasyon Mektubu</th>
                <th>Transkript</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((application, index) => (
                <tr key={index}>
                  <td>
                    {application.user.firstname} {application.user.lastname}
                  </td>
                  <td>{application.user.email}</td>
                  <td>{application.user.phone}</td>
                  <td>{application.university}</td>
                  <td>{application.department}</td>
                  <td>{application.graduationYear}</td>
                  <td>{application.internshipPeriod}</td>
                  <td>{application.interestedDepartments}</td>
                  <td>
                    {application.motivationUrl ? (
                      <a
                        href={application.cvUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Görüntüle
                      </a>
                    ) : (
                      'Yüklenmemiş'
                    )}
                  </td>
                  <td>
                    {application.motivationUrl ? (
                      <a
                        href={application.motivationUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Görüntüle
                      </a>
                    ) : (
                      'Yüklenmemiş'
                    )}
                  </td>
                  <td>
                    {application.transcriptUrl ? (
                      <a
                        href={application.transcriptUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Görüntüle
                      </a>
                    ) : (
                      'Yüklenmemiş'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminInternship;
*/
import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, query, orderBy, getDocs, doc, getDoc } from 'firebase/firestore';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import styles from './applications.module.css';

const AdminInternship = () => {
  const [applications, setApplications] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});

  useEffect(() => {
    const fetchApplications = async () => {
      try {
        const q = query(collection(db, 'internshipApplications'), orderBy('timestamp', 'desc'));
        const querySnapshot = await getDocs(q);
        const fetchedApplications = [];

        for (const docRef of querySnapshot.docs) {
          const application = docRef.data();
          const userId = application.userId;
          const userDocRef = doc(db, 'users', userId);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = userDoc.data();
            fetchedApplications.push({
              ...application,
              user: {
                email: userData.email,
                firstname: userData.firstName,
                lastname: userData.lastName,
                birthdate: userData.birthDate,
                phone: userData.phone,
              },
            });
          }
        }

        setApplications(fetchedApplications);
      } catch (error) {
        console.error('Error fetching internship applications: ', error);
      }
    };

    fetchApplications();
  }, []);

  const [filter, setFilter] = useState('');
  const [filteredApplications, setFilteredApplications] = useState([]);

  useEffect(() => {
    // Apply filter if needed (optional)
    if (filter) {
      setFilteredApplications(
        applications.filter((app) =>
          app.interestedDepartments.includes(filter)
        )
      );
    } else {
      setFilteredApplications(applications);
    }
  }, [applications, filter]);

  const handleToggleExpand = (index) => {
    setExpandedRows((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  // Functions to export to Excel and PDF
  const exportToExcel = () => {
    const dataToExport = applications.map((app) => ({
      'İsim Soyisim': `${app.user.firstname || ''} ${app.user.lastname || ''}`,
      'Email': app.user.email || 'N/A',
      'Telefon': app.user.phone || 'N/A',
      'Üniversite': app.university || 'N/A',
      'Bölüm': app.department || 'N/A',
      'Mezuniyet Yılı': app.graduationYear || 'N/A',
      'Staj Dönemi': app.internshipPeriod || 'N/A',
      'İlgilendiği Bölümler': app.interestedDepartments.join(', ') || 'N/A',
      'Başvuru Tarihi': app.timestamp && app.timestamp.toDate
        ? app.timestamp.toDate().toLocaleDateString()
        : 'N/A',
    }));

    const worksheet = XLSX.utils.json_to_sheet(dataToExport);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'InternshipApplications');
    XLSX.writeFile(workbook, 'internship_applications.xlsx');
  };

  const exportToPDF = () => {
    const doc = new jsPDF();
    doc.setFont('Helvetica');

    const data = applications.map((app) => [
      `${app.user.firstname || ''} ${app.user.lastname || ''}`,
      app.user.email || 'N/A',
      app.user.phone || 'N/A',
      app.university || 'N/A',
      app.department || 'N/A',
      app.graduationYear || 'N/A',
      app.internshipPeriod || 'N/A',
      app.interestedDepartments.join(', ') || 'N/A',
      app.timestamp && app.timestamp.toDate
        ? app.timestamp.toDate().toLocaleDateString()
        : 'N/A',
    ]);

    doc.autoTable({
      head: [
        [
          'İsim Soyisim',
          'Email',
          'Telefon',
          'Üniversite',
          'Bölüm',
          'Mezuniyet Yılı',
          'Staj Dönemi',
          'İlgilendiği Bölümler',
          'Başvuru Tarihi',
        ],
      ],
      body: data,
    });

    doc.save('internship_applications.pdf');
  };

  return (
    <div className={styles.container}>
      <div className={styles.mainContent}>
        <div className={styles.exportButtons}>
          <button className={styles.exportButton} onClick={exportToExcel}>
            Excel'e Aktar
          </button>
          <button className={styles.exportButton} onClick={exportToPDF}>
            PDF'e Aktar
          </button>
        </div>
        <div className={styles.tableContainer}>
          <table className={styles.applicationsTable}>
            <thead>
              <tr>
                <th>İsim Soyisim</th>
                <th>Email</th>
                <th>Telefon</th>
                <th>Üniversite</th>
                <th>Bölüm</th>
                <th>Mezuniyet Yılı</th>
                <th>Staj Dönemi</th>
                <th>İlgilendiği Bölümler</th>
                <th>CV</th>
                <th>Motivasyon Mektubu</th>
                <th>Transkript</th>
                <th>Cevaplar</th>
              </tr>
            </thead>
            <tbody>
              {applications.map((application, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td>
                      {application.user.firstname} {application.user.lastname}
                    </td>
                    <td>{application.user.email}</td>
                    <td>{application.user.phone}</td>
                    <td>{application.university}</td>
                    <td>{application.department}</td>
                    <td>{application.graduationYear}</td>
                    <td>{application.internshipPeriod}</td>
                    <td>{application.interestedDepartments.join(', ')}</td>
                    <td>
                      {application.cvUrl ? (
                        <a
                          href={application.cvUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Görüntüle
                        </a>
                      ) : (
                        'Yüklenmemiş'
                      )}
                    </td>
                    <td>
                      {application.motivationUrl ? (
                        <a
                          href={application.motivationUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Görüntüle
                        </a>
                      ) : (
                        'Yüklenmemiş'
                      )}
                    </td>
                    <td>
                      {application.transcriptUrl ? (
                        <a
                          href={application.transcriptUrl}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          Görüntüle
                        </a>
                      ) : (
                        'Yüklenmemiş'
                      )}
                    </td>
                    <td>
                      <button
                        className={styles.expandButton}
                        onClick={() => handleToggleExpand(index)}
                      >
                        {expandedRows[index] ? 'Gizle' : 'Göster'}
                      </button>
                    </td>
                  </tr>
                  {expandedRows[index] && (
                    <tr>
                      <td colSpan="12">
                        <ul className={styles.answersList}>
                          {application.answers && application.answers.length > 0 ? (
                            application.answers.map((answer, idx) => (
                              <li key={idx}>
                                <strong>{answer.question}:</strong> {answer.answer}
                              </li>
                            ))
                          ) : (
                            <li>Cevap bulunamadı.</li>
                          )}
                        </ul>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminInternship;